import React, { Component } from "react";
import Formsy from "formsy-react";
import FormsyText from "./forms/formComponents/FormsyText";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import {
  Paper,
  FlatButton,
  TextField,
  CircularProgress,
  MenuItem,
  Subheader,
  AppBar,
} from "material-ui";
import { red600, green400 } from "material-ui/styles/colors";
import { FormsySelect } from "formsy-material-ui/lib";
import Loading from "./Loading";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: "login",
      isLoggingIn: false,
      isRegistering: false,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
        },
      },
    };

    this.handleMessage = this.handleMessage.bind(this);
    this.loginForm = this.loginForm.bind(this);
    this.registerForm = this.registerForm.bind(this);
    this.setForm = this.setForm.bind(this);
    this.register = this.register.bind(this);
    this.login = this.login.bind(this);
  }

  componentWillMount() {
    this.props.setMessage("");
    if (this.props.token.user) {
      let { redirect } = this.props.location.query;
      if (redirect) {
        window.location.replace(redirect);
      } else {
        window.location.replace("/Home");
      }
    }
  }

  onSubmit(data) {
    this.setState({ isLoggingIn: true });
    let { redirect } = this.props.location.query;
    let route = this.state.form === "login" ? "login" : "login/new";
    this.props.login(data, redirect, route);
  }

  handleMessage() {
    if (this.props.loginMessage) {
      // this.setState({isLoggingIn: false})
      let message = this.props.loginMessage;
      if (message === "Incorrect Username or Password") {
        return (
          <div style={{ color: red600 }}>
            <br />
            {message}
            <br />
            {/*<a target="_blank" href="LINK_TO_PASSWORD_RESET">Forgot Password?</a>*/}
          </div>
        );
      } else if (message === "Failed to fetch") {
        return (
          <div style={{ color: red600 }}>
            <br />
            {"Could not login - No Connection"}
            <br />
          </div>
        );
      } else if (message === "locked") {
        return (
          <div style={{ color: red600 }}>
            <br />
            {
              "Your account is locked. Please contact the administrator for details."
            }
            <br />
          </div>
        );
      } else if (message === "new") {
        return (
          <div style={{ color: green400 }}>
            <br />
            {
              "Thank you for creating an account! It will be locked until it is reviewed by the adminstrator."
            }
            <br />
          </div>
        );
      } else {
        return (
          <div style={{ color: red600 }}>
            <br />
            {message}
            <br />
          </div>
        );
      }
    }
  }

  loginForm() {
    return (
      <center>
        <Paper
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <div className="documentPorterTitle">Document Porter</div>
          <div className="loginTitle">Login</div>
          <TextField
            required
            // autoComplete='off'
            ref="email"
            name="email"
            hintText="Email"
            floatingLabelText="Email"
          />
          <br />
          <TextField
            required
            ref="password"
            name="password"
            type="password"
            hintText="Password"
            floatingLabelText="Password"
          />
          <br />
          {this.handleMessage()}
          <br />
          <div className="row">
            <FlatButton
              label={
                this.state.isLoggingIn ? (
                  <CircularProgress
                    color={this.props.color || "#424242"}
                    size={25}
                    thickness={5}
                  />
                ) : (
                  "Login"
                )
              }
              disabled={this.state.isLoggingIn}
              // label='Log In'
              onClick={this.login.bind(this)}
              backgroundColor={"#E0E0E0"}
              hoverColor={"#BDBDBD"}
              style={{ margin: "0 auto" }}
            />
          </div>
          <br />
          <FlatButton
            label="Need an Account?"
            hoverColor="#BDBDBD"
            onClick={this.setForm.bind(this, "register")}
          />
          <br />
        </Paper>
      </center>
    );
  }

  registerForm() {
    return (
      <center>
        <Paper
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
        >
          <div className="documentPorterTitle">Document Porter</div>
          <div className="loginTitle">Registration Form</div>
          <TextField
            required
            // autoComplete='off'
            ref="email"
            name="email"
            hintText="Email"
            floatingLabelText="Email"
          />
          <br />
          <TextField
            required
            ref="password"
            name="password"
            type="password"
            hintText="Password"
            floatingLabelText="Password"
          />
          <br />
          <TextField
            required
            ref="confirmPassword"
            name="confirmPassword"
            type="password"
            hintText="Confirm Password"
            floatingLabelText="Confirm Password"
          />
          <br />
          <TextField
            required
            // autoComplete='off'
            ref="name"
            name="name"
            hintText="name"
            floatingLabelText="Name"
          />
          <br />
          {this.handleMessage()}
          <br />
          <div className="row">
            <FlatButton
              style={{ margin: "0 auto" }}
              label={
                this.state.isRegistering ? (
                  <CircularProgress
                    color={this.props.color || "#424242"}
                    size={25}
                    thickness={5}
                  />
                ) : (
                  "Register"
                )
              }
              disabled={this.state.isRegistering}
              onClick={this.register.bind(this)}
              backgroundColor="#E0E0E0"
              hoverColor="#BDBDBD"
            />
          </div>
          <br />
          <FlatButton
            label="Already have an Account?"
            hoverColor="#BDBDBD"
            onClick={this.setForm.bind(this, "login")}
          />
          <br />
        </Paper>
      </center>
    );
  }

  setForm(form) {
    this.props.setMessage("");
    this.setState({ form });
  }

  login() {
    if (
      this.refs.email.getValue() === "" ||
      this.refs.password.getValue() === ""
    ) {
      this.props.setMessage("Please enter your email and password to login");
    } else {
      // this.setState({isLoggingIn: true})
      let { redirect } = this.props.location.query;
      let route = "api/login";
      let data = {
        email: this.refs.email.getValue(),
        password: this.refs.password.getValue(),
      };
      this.props.login(data, redirect, route);
    }
  }

  register() {
    let email = this.refs.email.getValue();
    let password = this.refs.password.getValue();
    let confirmPassword = this.refs.confirmPassword.getValue();
    let name = this.refs.name.getValue();
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (email && email.length && !email.match(isValidEmail)) {
      this.props.setMessage("Please enter a valid email");
    } else if (email === "" || password === "") {
      this.props.setMessage("Please enter your email");
    } else if (confirmPassword === "") {
      this.props.setMessage("Please confirm your password");
    } else if (password !== confirmPassword) {
      this.props.setMessage("Passwords do not match, please try again.");
    } else if (name === "") {
      this.props.setMessage("Please enter your name");
    } else if (email && password && name) {
      let redirect = "/Login";
      let route = "api/login/new";
      let data = {
        email: email,
        password: password,
        name: name,
      };
      this.props.login(data, redirect, route);
    } else {
      this.props.setMessage(
        "Error registering, please contact the administrator",
      );
    }
  }

  render() {
    let { centerStyle } = this.state;
    console.log("this state------------", this.state.form);
    let form = this.state.form === "login" ? this.loginForm : this.registerForm;

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <MuiThemeProvider muiTheme={getMuiTheme()}>
          <div className="app">
            <nav className="navbar-fixed-top">
              <AppBar
                title={"Document Porter Login"}
                style={{ background: "#2979ff" }}
                showMenuIconButton={window.screen.width < 600 ? true : false}
              />
            </nav>
            <br />
            <br />
            <br />
            <div className="container">
              <div className="col-sm-6" style={{ marginLeft: "25%" }}>
                <br />
                {form()}
              </div>
              <div className="col-sm-4"></div>
            </div>
            <br />
            <br />
            <br />
          </div>
        </MuiThemeProvider>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/Login.js